import { render, staticRenderFns } from "./non-uom-bp-prices.vue?vue&type=template&id=182be568"
import script from "./non-uom-bp-prices.vue?vue&type=script&lang=js"
export * from "./non-uom-bp-prices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports